import { render, staticRenderFns } from "./PrivacyContent.vue?vue&type=template&id=65d075df&scoped=true&"
import script from "./PrivacyContent.vue?vue&type=script&lang=ts&"
export * from "./PrivacyContent.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyContent.vue?vue&type=style&index=0&id=65d075df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d075df",
  null
  
)

export default component.exports